export default {
  cancelText: 'Avbryt'
};
